export type SingleOrderStatus = {
	orderId: string;
	status: string;
	startDate: string;
	msisdn: string;
	productId: string;
};

const model: types.models.InputModel = {
	orderId: 'orderId',
	status: 'status',
	startDate: 'startDate',
	msisdn: 'msisdn',
	productId: 'productId',
};

export default model;
